import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Contact } from 'src/model/contact.model';

@Component({
    selector: 'app-add-contact',
    templateUrl: './add-contact.component.html',
    styleUrls: ['./add-contact.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class AddContactComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private datepipe = inject(DatePipe);

  name: string;
  contactNum: string;
  address: string;
  icNumber: string;
  relation: string;
  remark: string;
  dob: Date;

  @Input() viewCustomerId: string;
  @Input() isDialog = true;

  @Input() contactToUpdate: Contact;

  disableSubmit = false;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.contactToUpdate != undefined) {
      this.name = this.contactToUpdate.Name;
      this.contactNum = this.contactToUpdate.ContactNumber;
      this.address = this.contactToUpdate.Address;
      this.icNumber = this.contactToUpdate.ICNumber;
      this.relation = this.contactToUpdate.Relation;
      this.remark = this.contactToUpdate.Remark;
      this.dob = this.contactToUpdate.DOB;
    }
  }

  checkValidity() {
    let errorStr = "";

    if (this.name == "" || this.name == undefined)
      errorStr += "- Contact Name\n";

    if (this.icNumber == "" || this.icNumber == undefined)
      errorStr += "- IC Number\n";
    else if ((this.sharedService.checkIfICValid(this.icNumber) == false) && this.sharedService.isBossAccount() == false)
      errorStr += "- IC Number format invalid\n";

    if (this.contactNum == "" || this.contactNum == undefined)
      errorStr += "- Contact Number\n";
    if (this.relation == "" || this.relation == undefined)
      errorStr += "- Relation\n";
    // if (this.dob == undefined)
    //   errorStr += "- DOB\n";

    if (errorStr != "")
      return "Please key in correct information:\n " + errorStr;
    else
      return errorStr;
  }

  submit() {
    this.disableSubmit = true;
    const message = this.checkValidity();
    if (message == "") {
      this.addContact();
    }
    else {
      this.sharedService.openAlert(message, ALERT_TYPE.DANGER);
      this.disableSubmit = false;
    }
  }

  addContact() {
    const icNumberFormat = this.icNumber.replace(/-/g, "",);
    const data = {
      "name": this.name, "icNumber": icNumberFormat, "number": this.contactNum, "address": this.address, "customerId": this.viewCustomerId,
      "relation": this.relation, "remark": this.remark, "dob": this.datepipe.transform(this.dob, "yyyy-MM-dd")
    };
    const xhr = (this.contactToUpdate == undefined) ? this.restapi.postRequest(this.constructApi.getAddContact(), data) : this.restapi.putRequest(this.constructApi.getUpdateContact(this.contactToUpdate.ID), data);

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);

        const contact = new Contact(json.id, json.name, json.icNumber, json.number, json.address, json.customerId, json.relation, json.remark, true, undefined, undefined, undefined, undefined, undefined, undefined, json.dob);
        if (this.contactToUpdate == undefined) {
          this.passEntry.emit(contact)
          this.reset();
          this.sharedService.openAlert("Successfully added contact!", ALERT_TYPE.SUCCESS);
        }
        else
          window.location.reload();
      }
    }
  }

  reset() {
    this.activeModal.close();
    this.name = "";
    this.contactNum = "";
    this.address = "";
    this.remark = "";
    this.relation = "";
    this.dob = undefined;
  };
}
